// CMS entries for dfsweb-rewamp-assets override these at runtime.
export const en = {
  "ASSETS_FILTER_ROW.ARIA": "Filter assets",
};

export const hi = {
  "ASSETS_FILTER_ROW.ARIA": "कृषि संसाधन फ़िल्टर करें",
};
